const PrivacyPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto p-6  text-gray-800">
      <h1 className="sm:text-2xl text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="mb-4">Effective Date: 20/04/2025</p>

      <p className="mb-4">
        At thezaik.com, we value your trust and are committed to protecting your
        privacy. This Privacy Policy explains how we collect, use, disclose, and
        safeguard your information when you visit our website or interact with
        our services. By using our website, you agree to the collection and use
        of information in accordance with this policy.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Information We Collect
      </h2>
      <h3 className="font-semibold mt-4">1.1 Personal Information</h3>
      <p className="mb-4">
        We collect personal details that you voluntarily provide during the
        checkout or account creation process, including:
        <ul className="list-disc list-outside pl-4 mt-2">
          <li>Full Name</li>
          <li>Email Address</li>
          <li>Phone Number</li>
          <li>Shipping/Billing Address</li>
          <li>Payment Method (type only, not full card details)</li>
        </ul>
      </p>

      <h3 className="font-semibold mt-4">
        1.2 Automatically Collected Information
      </h3>
      <p className="mb-4">
        We do not use cookies or any third-party analytics tools to collect
        automatic data (e.g., IP address, browser type, or usage statistics).
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. How We Use Your Information
      </h2>
      <p className="mb-4">
        We use the information we collect to:
        <ul className="list-disc list-outside pl-4 mt-2">
          <li>Fulfill and manage orders, payments, and deliveries</li>
          <li>Send transactional emails or order confirmations</li>
          <li>Improve customer service and respond to inquiries</li>
          <li>
            Prevent fraudulent transactions and ensure a secure shopping
            environment
          </li>
          <li>Comply with legal obligations and regulations</li>
        </ul>
        We do not use your data for marketing purposes unless explicitly
        consented.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Sharing of Information
      </h2>
      <p className="mb-4">
        Your privacy is important to us. We only share personal data in limited
        circumstances:
        <ul className="list-disc list-outside pl-4 mt-2">
          <li>
            <strong>Logistics & Delivery Partners:</strong> Your shipping
            information may be shared with third-party delivery services to
            ensure successful order fulfillment.
          </li>
          <li>
            <strong>Payment Gateways:</strong> Payment information is processed
            securely through trusted third-party payment processors. We do not
            store or have access to your full payment details.
          </li>
          <li>
            <strong>Legal Obligations:</strong> We may disclose personal data if
            required by law or in response to valid legal requests by public
            authorities (e.g., a court or a government agency).
          </li>
        </ul>
        We do not sell, rent, or trade your personal information to third
        parties for marketing or advertising purposes.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Data Retention</h2>
      <p className="mb-4">
        We retain your personal data only as long as necessary to fulfill the
        purposes outlined in this Privacy Policy, unless a longer retention
        period is required or permitted by law. When data is no longer required,
        it is securely deleted.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Data Security</h2>
      <p className="mb-4">
        We use appropriate technical and organizational measures to protect the
        information we collect and store. These include:
        <ul className="list-disc list-outside pl-4 mt-2">
          <li>Secure server infrastructure</li>
          <li>HTTPS encryption</li>
          <li>Restricted access controls</li>
          <li>Regular software updates and vulnerability scans</li>
        </ul>
        Despite our efforts, no method of transmission over the internet is 100%
        secure. Therefore, we cannot guarantee absolute security.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        6. Your Rights and Choices
      </h2>
      <p className="mb-4">
        As a user, you have the right to:
        <ul className="list-disc list-outside pl-4 mt-2">
          <li>Request access to the personal data we hold about you</li>
          <li>Request correction or deletion of your personal data</li>
          <li>Withdraw your consent to processing (where applicable)</li>
          <li>
            File a complaint with a data protection authority if you believe
            your rights are violated
          </li>
        </ul>
        To exercise any of these rights, please contact us at
        zaikcare@gmail.com.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Children’s Privacy</h2>
      <p className="mb-4">
        Our website is not intended for use by individuals under the age of 13.
        We do not knowingly collect personal information from children. If you
        believe that a child has provided us with personal data, please contact
        us, and we will take steps to remove such information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">8. Third-Party Links</h2>
      <p className="mb-4">
        Our website may contain links to third-party websites. This Privacy
        Policy does not apply to third-party services, and we are not
        responsible for the privacy practices of those sites. We recommend
        reviewing their privacy policies before sharing personal information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        9. Changes to This Privacy Policy
      </h2>
      <p className="mb-4">
        We may update this Privacy Policy from time to time to reflect changes
        in our practices or legal requirements. When we make changes, we will
        revise the "Effective Date" at the top of this policy. We encourage you
        to review this page periodically for the latest information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">10. Contact Us</h2>
      <p className="mb-4">
        If you have any questions, concerns, or requests regarding this Privacy
        Policy or the way your personal data is handled, please contact us at:
        <br />
        📧 Email: zaikcare@gmail.com
        <br />
        🌐 Website: www.zaik.com
      </p>
    </div>
  );
};

export default PrivacyPolicy;
